import {useMutation} from "@tanstack/react-query";
import {activateCurrentUserManagementUserMutationOptions} from "./activate-current-user-management-user.mutation-options";

export function useActivateCurrentUserManagementUser() {
  return useMutation(activateCurrentUserManagementUserMutationOptions());
}
